import { useCallback } from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'
import { MeetingTemplate } from '../../../../../store/ai/meetingTemplate'
import { parseMetadata } from '../../../../../common/util'
import { useAppSelector } from '../../../../../store/hooks'
import { selectSelectedMeetingTemplate } from '../../../../../store/meetingSummary/meetingTemplates'

interface UseAgendaFeatureResponse {
  isAgendaEnabledForAccount: boolean
  checkIsAgendaEnabledForMeetingTemplate: (meetingTemplate?: MeetingTemplate | null) => boolean
}

export const useAgendaFeature = (): UseAgendaFeatureResponse => {
  const { hasQuota } = useZocksQuota()
  const hasAgendaQuota = hasQuota('ai.agenda.value')

  const checkIsAgendaEnabledForMeetingTemplate = useCallback(
    (meetingTemplate?: MeetingTemplate | null) => {
      if (!meetingTemplate || !hasAgendaQuota) {
        return false
      }

      const metadata = parseMetadata(meetingTemplate.metadata)
      return metadata?.isAgendaEnabled === true
    },
    [hasAgendaQuota],
  )

  return {
    isAgendaEnabledForAccount: hasAgendaQuota,
    checkIsAgendaEnabledForMeetingTemplate,
  }
}

export const useSelectedMeetingTemplateHasAgendaEnabled = () => {
  const { checkIsAgendaEnabledForMeetingTemplate } = useAgendaFeature()
  const selectedMeetingTemplate = useAppSelector(selectSelectedMeetingTemplate)
  return checkIsAgendaEnabledForMeetingTemplate(selectedMeetingTemplate)
}
